import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0da4423c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full h-full help-bg-body" }
const _hoisted_2 = { class: "tool-bar" }
const _hoisted_3 = { class: "menu-box flex flex-col w-full px-4 py-6 m-0 overflow-y-auto" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "text-base" }
const _hoisted_6 = {
  key: 0,
  href: "https://3cx-globish.my3cx.sg:5001/LiveChat449480",
  class: "menu-nav-list-item w-full",
  target: "_blank"
}
const _hoisted_7 = { class: "text-base" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "text-base" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "text-base" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "text-base" }
const _hoisted_14 = { class: "header py-4 pl-2" }
const _hoisted_15 = { class: "flex flex-col w-full" }
const _hoisted_16 = { class: "flex flex-row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rectangle" }, null, -1))
const _hoisted_18 = { class: "text-black text-sm dark:text-white py-4" }
const _hoisted_19 = { class: "flex flex-col gap-2 p-4" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "text-center text-black dark:text-white mt-2 text-sm"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header py-4 pl-2" }, "Are you experiencing any problems?", -1))
const _hoisted_23 = { class: "flex flex-col w-full" }
const _hoisted_24 = { class: "flex flex-row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rectangle" }, null, -1))
const _hoisted_26 = { class: "text-black text-sm dark:text-white py-4" }
const _hoisted_27 = { class: "flex flex-col gap-2 p-4" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 2,
  class: "text-center text-black dark:text-white mt-2 text-sm"
}
const _hoisted_31 = { class: "room-version" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "About", -1))

import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/24/solid'
import { HelpAction, SolveAction } from '../../types/enums/help.enum'
import { changeToEngine, isOpenChangeVideoEngine } from '@/composables/room/useRoomLayout'
import { Engine } from '../../types/enums/room.enum'
import { studentHelpList, coachHelpList } from '@/data/mock-help-menu'
import { PropType, computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoomLayoutStore } from '@/stores/room-layout.store'
import { useRoomStore } from '@/stores'


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpCollapse',
  props: {
  isCoachRole: {
    type: Boolean,
    default: false,
  },
  isStudentRole: {
    type: Boolean,
    default: false,
  },
  engineWhereby: {
    type: Boolean,
    default: false,
  },
  engineControl: {
    type: Boolean,
    default: false,
  },
  country: {
    type: String,
    default: 'th',
  },
  currentEngine: {
    type: String as PropType<Engine>,
    default: Engine.TWILIO,
  },
  isMainEngine: {
    type: Boolean,
    default: true,
  },
  helpEnable: {
    type: Boolean,
    default: false,
  },
  canMoveRoomByCoach: {
    type: Boolean,
    default: true,
  },
},
  emits: ['help-solve-confirm', 'on-close'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const roomStore = useRoomStore()
const roomLayoutStore = useRoomLayoutStore()
const reloadTooltip = ref<boolean>(false)
const moveRoomSecondaryTooltip = ref<boolean>(false)
const moveRoomWherebyTooltip = ref<boolean>(false)
const moveRoomMainTooltip = ref<boolean>(false)
const disableChangeRoomTooltip = ref<boolean>(false)
const { t, locale } = useI18n()

const studentHelpMenuList = computed(() => studentHelpList(props.isMainEngine))
const coachHelpMenuList = computed(() => coachHelpList(props.isMainEngine))
const helpHeader = computed(() => {
  return {
    th: 'ท่านกำลังพบเจอปัญหาใด?',
    vn: 'Vấn đề bạn đang gặp phải là gì?',
    en: 'What is the problem you are encountering?',
  }
})
const localKey = computed(() => {
  switch (locale.value) {
    case 'th':
      return 'th'
    case 'vn':
      return 'vn'
    default:
      return 'en'
  }
})
const disableChangeRoom = computed(() => !props.canMoveRoomByCoach && props.isCoachRole)
const reload = () => {
  window.location.reload()
}
const openChangeVideoEngine = () => {
  isOpenChangeVideoEngine.value = true
  roomLayoutStore.isOpenChangeVideoEngine = true
}

const openChangeVideoWherebyEngine = () => {
  isOpenChangeVideoEngine.value = true
  changeToEngine.value = Engine.WHEREBY
  roomLayoutStore.isOpenChangeVideoEngine = true
  roomLayoutStore.changeToEngine = Engine.WHEREBY
}
const emitOpenPopup = (action: HelpAction, solved?: SolveAction) => {
  const helpRequest = {
    action: action,
    solvedBy: solved,
  }
  emit('help-solve-confirm', helpRequest)
}

const disclosureIndex = ref<number>()
const closeHelpMenu = () => {
  emit('on-close')
}
const toggleMenu = (index: number) => {
  if (disclosureIndex.value === index) {
    disclosureIndex.value = undefined
  } else {
    disclosureIndex.value = index
  }
}

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Popper = _resolveComponent("Popper")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('help')), 1),
      _createVNode(_component_SvgIcon, {
        class: "close-btn _pointer-on-hover",
        icon: "close",
        height: "25",
        "inherit-fill": true,
        onClick: closeHelpMenu
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Popper, {
          class: "poper-tooltip",
          hover: true,
          arrow: true,
          content: _unref(t)('help-content.reload-tooltip'),
          onMouseover: _cache[0] || (_cache[0] = ($event: any) => (reloadTooltip.value = true)),
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (reloadTooltip.value = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              class: "menu-nav-list-item w-full",
              onClick: reload
            }, [
              _createVNode(_component_SvgIcon, {
                class: "_pointer-on-hover ml-1 mr-3 menu-icon",
                icon: "reload",
                "inherit-fill": true,
                height: "22"
              }),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('reload-room')), 1)
            ])
          ]),
          _: 1
        }, 8, ["content"]),
        (__props.isStudentRole && __props.country === 'th')
          ? (_openBlock(), _createElementBlock("a", _hoisted_6, [
              _createVNode(_component_SvgIcon, {
                class: "_pointer-on-hover ml-1 mr-3 menu-icon",
                icon: "siren",
                "inherit-fill": true,
                height: "22"
              }),
              _createElementVNode("strong", _hoisted_7, _toDisplayString(_ctx.$t('help-contact-support')), 1)
            ]))
          : _createCommentVNode("", true),
        (__props.engineControl || __props.engineWhereby)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (__props.engineControl)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (__props.isMainEngine)
                      ? (_openBlock(), _createBlock(_component_Popper, {
                          key: 0,
                          class: "poper-tooltip",
                          hover: true,
                          arrow: true,
                          content: 
                disableChangeRoom.value
                  ? _unref(t)('help-content.main-change-room-with-disabled')
                  : _unref(t)('help-content.main-change-room')
              ,
                          onMouseover: _cache[2] || (_cache[2] = ($event: any) => (moveRoomSecondaryTooltip.value = true)),
                          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (moveRoomSecondaryTooltip.value = false))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              class: "menu-nav-list-item",
                              disabled: disableChangeRoom.value,
                              onClick: openChangeVideoEngine
                            }, [
                              _createVNode(_component_SvgIcon, {
                                class: "_pointer-on-hover ml-1 mr-3 menu-icon",
                                icon: "siren",
                                "inherit-fill": true,
                                height: "19"
                              }),
                              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('move-secondary-room')), 1)
                            ], 8, _hoisted_8)
                          ]),
                          _: 1
                        }, 8, ["content"]))
                      : (_openBlock(), _createBlock(_component_Popper, {
                          key: 1,
                          class: "poper-tooltip",
                          hover: true,
                          arrow: true,
                          content: 
                disableChangeRoom.value
                  ? _unref(t)('help-content.second-change-room-with-disabled')
                  : _unref(t)('help-content.second-change-room')
              ,
                          onMouseover: _cache[4] || (_cache[4] = ($event: any) => (moveRoomMainTooltip.value = true)),
                          onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (moveRoomMainTooltip.value = false))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              class: "menu-nav-list-item",
                              disabled: disableChangeRoom.value,
                              onClick: openChangeVideoEngine
                            }, [
                              _createVNode(_component_SvgIcon, {
                                class: "_pointer-on-hover ml-1 mr-3 menu-icon",
                                icon: "change-room",
                                "inherit-fill": true,
                                height: "19"
                              }),
                              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('move-main-room')), 1)
                            ], 8, _hoisted_10)
                          ]),
                          _: 1
                        }, 8, ["content"]))
                  ], 64))
                : _createCommentVNode("", true),
              (__props.engineWhereby)
                ? (_openBlock(), _createBlock(_component_Popper, {
                    key: 1,
                    class: "poper-tooltip",
                    hover: true,
                    arrow: true,
                    content: 
                disableChangeRoom.value
                  ? 'Must have student enter class before change room'
                  : 'Click here to move the whereby room.'
              ,
                    onMouseover: _cache[6] || (_cache[6] = ($event: any) => (moveRoomWherebyTooltip.value = true)),
                    onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (moveRoomWherebyTooltip.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "menu-nav-list-item",
                        disabled: disableChangeRoom.value,
                        onClick: openChangeVideoWherebyEngine
                      }, [
                        _createVNode(_component_SvgIcon, {
                          class: "_pointer-on-hover ml-1 mr-3 menu-icon",
                          icon: "siren",
                          "inherit-fill": true,
                          height: "19"
                        }),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('move-whereby-room')), 1)
                      ], 8, _hoisted_12)
                    ]),
                    _: 1
                  }, 8, ["content"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      (__props.isStudentRole)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(helpHeader.value[localKey.value]), 1),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(studentHelpMenuList.value, (help, index) => {
                return (_openBlock(), _createBlock(_unref(Disclosure), {
                  key: `help-collapse-${index}`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DisclosureButton), {
                      class: "help-header w-full flex items-center text-left text-base",
                      onClick: ($event: any) => (toggleMenu(index))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(help.header[localKey.value]), 1),
                        _createVNode(_unref(ChevronDownIcon), {
                          class: _normalizeClass(["ml-auto h-5 w-5", disclosureIndex.value === index ? 'rotate-180 transform' : ''])
                        }, null, 8, ["class"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _withDirectives(_createVNode(_unref(DisclosurePanel), {
                      static: true,
                      class: "text-base px-3"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_16, [
                          _hoisted_17,
                          _createElementVNode("p", _hoisted_18, _toDisplayString(help.content?.[localKey.value]), 1)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(help.choices, (choice, id) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `solved-btn-${id}`,
                              class: "w-full"
                            }, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn choice-btn w-full",
                                onClick: ($event: any) => (emitOpenPopup(help.action, choice.solveBy))
                              }, [
                                _createVNode(_component_SvgIcon, {
                                  class: "_pointer-on-hover ml-1 mr-3 choice-icon",
                                  icon: choice.icon,
                                  "inherit-fill": true,
                                  height: "20"
                                }, null, 8, ["icon"]),
                                _createElementVNode("p", null, _toDisplayString(choice.label[localKey.value]), 1)
                              ], 8, _hoisted_20),
                              (
                      help.choices?.length &&
                      help.choices?.length > 1 &&
                      id < help.choices?.length - 1
                    )
                                ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.$t('or')), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1536), [
                      [_vShow, disclosureIndex.value === index]
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true),
      (__props.isCoachRole)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coachHelpMenuList.value, (help, index) => {
                return (_openBlock(), _createBlock(_unref(Disclosure), {
                  key: `help-collapse-${index}`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DisclosureButton), {
                      class: "help-header w-full flex items-center text-left",
                      onClick: ($event: any) => (toggleMenu(index))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString('th' == _unref(locale) ? help.header.th : help.header.en), 1),
                        _createVNode(_unref(ChevronDownIcon), {
                          class: _normalizeClass(["ml-auto h-5 w-5", disclosureIndex.value === index ? 'rotate-180 transform' : ''])
                        }, null, 8, ["class"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _withDirectives(_createVNode(_unref(DisclosurePanel), {
                      static: true,
                      class: "text-base px-3"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(locale) === 'th' ? help.content?.th : help.content?.en), 1)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(help.choices, (choice, id) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `solved-btn-${id}`,
                              class: "w-full"
                            }, [
                              (
                      disableChangeRoom.value &&
                      _unref(roomStore).isNightTime &&
                      choice.solveBy === _unref(SolveAction).MOVE_ROOM
                    )
                                ? (_openBlock(), _createBlock(_component_Popper, {
                                    key: 0,
                                    class: "poper-tooltip",
                                    placement: "top",
                                    hover: true,
                                    arrow: true,
                                    content: "Must have student enter class before change room",
                                    onMouseover: _cache[8] || (_cache[8] = ($event: any) => (disableChangeRoomTooltip.value = true)),
                                    onMouseleave: _cache[9] || (_cache[9] = ($event: any) => (disableChangeRoomTooltip.value = false))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn choice-btn w-full",
                                        disabled: "",
                                        onClick: ($event: any) => (emitOpenPopup(help.action, choice.solveBy))
                                      }, [
                                        _createVNode(_component_SvgIcon, {
                                          class: "_pointer-on-hover ml-1 mr-3 choice-icon",
                                          icon: choice.icon,
                                          "inherit-fill": true,
                                          height: "20"
                                        }, null, 8, ["icon"]),
                                        _createElementVNode("p", null, _toDisplayString(_unref(locale) === 'th' ? choice.label.th : choice.label.en), 1)
                                      ], 8, _hoisted_28)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "btn choice-btn w-full",
                                    onClick: ($event: any) => (emitOpenPopup(help.action, choice.solveBy))
                                  }, [
                                    _createVNode(_component_SvgIcon, {
                                      class: "_pointer-on-hover ml-1 mr-3 choice-icon",
                                      icon: choice.icon,
                                      "inherit-fill": true,
                                      height: "20"
                                    }, null, 8, ["icon"]),
                                    _createElementVNode("p", null, _toDisplayString(_unref(locale) === 'th' ? choice.label.th : choice.label.en), 1)
                                  ], 8, _hoisted_29)),
                              (
                      help.choices?.length &&
                      help.choices?.length > 1 &&
                      id < help.choices?.length - 1
                    )
                                ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.$t('or')), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1536), [
                      [_vShow, disclosureIndex.value === index]
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_31, [
        _hoisted_32,
        _createElementVNode("small", null, _toDisplayString(_unref(roomStore).currentTag), 1)
      ])
    ])
  ], 512)), [
    [_vShow, __props.helpEnable]
  ])
}
}

})